import { envPublic } from '@/libs/config';
import { getAuthToken } from '@/libs/firebase/auth';
import { applyInterceptors, createApiClient } from '../api-client';
import { createApiFactory } from '../api-factory';
import {
  createAuthInterceptor,
  createBookingEngineBaseUrlInterceptor,
  createDebugLogRequestInterceptor,
  createDebugLogResponseInterceptor,
  createErrorInterceptor,
  createNetworkCheckInterceptor,
  createNetworkRetryInterceptor,
} from '../interceptors';
import type { TokenProvider } from '../types';

const firebaseTokenProvider: TokenProvider = {
  getAccessToken: async () => {
    return await getAuthToken();
  },
  getRefreshToken: async () => null,
  setTokens: async () => {},
  clearTokens: async () => {},
};

// `baseURL` here is just the dev default; the request interceptor below
// overrides it per-request based on the selected env.
const client = createApiClient({
  baseURL: envPublic.bookingEngineApiUrl,
});

applyInterceptors(
  client,
  [
    createDebugLogRequestInterceptor(),
    createBookingEngineBaseUrlInterceptor(),
    createAuthInterceptor(firebaseTokenProvider),
    createNetworkCheckInterceptor(),
  ],
  [
    createDebugLogResponseInterceptor(),
    createNetworkRetryInterceptor(client),
    createErrorInterceptor(),
  ],
);

export const bookingEngineService = createApiFactory(client);
